var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0L0 6v12.1L11 24l11-5.9v-12L11 0zm7.9 6.6L11 10.9 3.1 6.6 11 2.3l7.9 4.3zM2 8.2l8 4.4-3.9 2.2L2 16.9V8.2zm10 13v-8.6l8-4.3v8.6l-8 4.3z",
    fill: "currentColor"
  })));
}

export default SvgIconBox;